import { ThemeProvider as EmotionProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material';
import { AppContextProvider } from './AppContextProvider';
import { DrawerProvider } from './DrawerProvider';
import { HeaderProvider } from './HeaderProvider';
import { useThemeContext } from '../theme';
import { BreadcrumbsProvider } from './BreadcrumbsProvider';
import { ProductsProvider } from '../../modules/products';
import { ProviderCompose } from '../components';
import { AuthProvider, PermifyProvider } from 'modules/auth/context';
import { OriginatorProvider } from 'modules/common/OriginatorProvider';
import { ReactNode } from 'react';
import { CessionProvider } from 'modules/cession/context/CessionProvider';

export interface IAppProviderProps {
  children: ReactNode;
}

const AppProvider = ({ children }: IAppProviderProps) => {
  const { state } = useThemeContext();

  return (
    <EmotionProvider theme={state.theme.light}>
      <ProviderCompose
        contexts={[
          <ThemeProvider theme={state.theme.light} key="theme-context" />,
          <AppContextProvider key="app-context" />,
          <AuthProvider key="auth-context" />,
          <OriginatorProvider key="originator-context" />,
          <PermifyProvider key="permify-context" />,
          <BreadcrumbsProvider key="breadcrumb-context" />,
          <DrawerProvider key="drawer-context" />,
          <ProductsProvider key="products-context" />,
          <CessionProvider key="cession-context" />,
          <HeaderProvider key="header-context" />,
        ]}
      >
        {children}
      </ProviderCompose>
    </EmotionProvider>
  );
};

export default AppProvider;
